const HISTORICAL_DATA_REGION_LABELS: Record<string, string> = {
  GLOBAL: "Global (all regions)",
  UK: "UK Solicitors",
  UK_BAR: "UK Bar",
  EMEA: "EMEA",
  APAC: "Asia Pacific",
  LATAM: "Latin America",
  Caribbean: "Caribbean",
  US: "United States",
  Canada: "Canada",
  Deutschland: "Deutschland",
};

export function historicalDataRegionLabel(regionId: string): string {
  return HISTORICAL_DATA_REGION_LABELS[regionId] ?? regionId;
}

export function formatHistoricalDataRegions(regionIds: string[]): string {
  return regionIds.length > 0 ? regionIds.map(historicalDataRegionLabel).join(", ") : "—";
}
